import { Stack } from 'expo-router';
import { ThemeProvider } from 'expo-router/react-navigation';

import { NAV_THEME } from '@/lib/theme';

export default function AdminProfileTabLayout() {
  return (
    <ThemeProvider value={NAV_THEME.dark}>
      <Stack screenOptions={{ headerShown: false }} />
    </ThemeProvider>
  );
}
